<pcs-traffic-lights-list [extended]="true" [trafficLights]="data"></pcs-traffic-lights-list>
